import { getStyleProperty } from "./getStyleProperty";

export function isVisible(element: HTMLElement) {
  if (!element) {
    return false;
  }

  return (
    getStyleProperty(element, "display") !== "none" &&
    getStyleProperty(element, "visibility") !== "hidden" &&
    getStyleProperty(element, "opacity") !== "0" &&
    element.offsetWidth > 0 &&
    element.offsetHeight > 0
  );
}
